import { render } from "./MyFxPreview.vue?vue&type=template&id=cba8558c"
import script from "./MyFxPreview.vue?vue&type=script&lang=js"
export * from "./MyFxPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__